import React, { useState, useContext } from "react";
import {
    CardContent,
    Card,
    CardHeader,
    Grid,
    Button,
    CircularProgress
} from "@material-ui/core";
import { OfficeContext } from "../../OfficeContext";
import { appContext } from "../../../../contexts/app";
import { PagingContext } from "../PagingContext";
import insyncHttps from "../../../../insyncHttps/insyncHttps";
import ModifyPerson from "./ModifyPerson";

export default function(props) {
    const { getPaging } = useContext(PagingContext);
    const { error } = useContext(appContext);
    const handleClose = props.handleClose;
    const personId = props.personId;
    const [person, setPerson] = useState({ ...props.person });
    const [loading, setLoading] = useState(false);
    const { officeId } = useContext(OfficeContext);
    const ref = props.ref;

    return (
        <Card ref={ref} style={{ margin: "auto" }}>
            <CardHeader title="Edit Person" />
            <CardContent>
                <Grid
                    container
                    style={{ maxHeight: "400px", overflowY: "scroll" }}
                >
                    <ModifyPerson
                        person={person}
                        handleChange={p => {
                            setPerson({ ...p });
                        }}
                    ></ModifyPerson>
                </Grid>
                <Button
                    variant="contained"
                    onClick={() => {
                        const req = {
                            officeId,
                            personId,
                            ...person
                        };
                        setLoading(true);
                        insyncHttps.paging
                            .updatePerson(req)
                            .then(result => {
                                setLoading(false);
                                getPaging();
                                handleClose();
                            })
                            .catch(err => {
                                console.error(err);
                                setLoading(false);
                                error.setMessage(err.message);
                            });
                    }}
                >
                    Submit
                </Button>
                {loading && <CircularProgress size={10} />}
            </CardContent>
        </Card>
    );
}
